module.exports = __webpack_public_path__ + "static/img/news.5bd080a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/news.png
// module id = j9U/
// module chunks = 1